import { API_V2_URL } from 'utils/constants';
import { RequestHelper } from 'utils';

// GET
const healthcheck = () => RequestHelper.GET(`${API_V2_URL}/ping`);

export const HealthcheckService = {
  healthcheck
};
